import { render, staticRenderFns } from "./OrganizerSelection.vue?vue&type=template&id=ed543af0&"
import script from "./OrganizerSelection.vue?vue&type=script&lang=js&"
export * from "./OrganizerSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports